import { Variants, Transition } from 'framer-motion'

export const SPRING: Transition = {
  type: 'spring',
  stiffness: 50,
  damping: 10,
  mass: 0.9
}

export const SPRING_FAST: Transition = {
  type: 'spring',
  stiffness: 120,
  damping: 14
}

export const UP: Variants = {
  hidden: { y: 80, opacity: 0, filter: 'blur(8px)' },
  show: {
    y: 0,
    opacity: 1,
    filter: 'blur(0px)',
    transition: SPRING
  }
}

export const LEFT: Variants = {
  hidden: { x: -80, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: SPRING
  }
}

export const RIGHT: Variants = {
  hidden: { x: 80, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: SPRING
  }
}

export const SCALE: Variants = {
  hidden: { scale: 0.8, opacity: 0, filter: 'blur(6px)' },
  show: {
    scale: 1,
    opacity: 1,
    filter: 'blur(0px)',
    transition: SPRING
  }
}

export const STAGGER = (d = 0.08): Variants => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren: d,
      delayChildren: 0.1
    }
  }
})

export const CHAR: Variants = {
  hidden: { y: '110%', opacity: 0, rotate: 5 },
  show: (i: number) => ({
    y: '0%',
    opacity: 1,
    rotate: 0,
    transition: { ...SPRING, delay: i * 0.035 }
  })
}

export const LINE: Variants = {
  hidden: { scaleX: 0, originX: 0 },
  show: {
    scaleX: 1,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
  }
}

export const GLOW = {
  animate: {
    boxShadow: [
      '0 0 0px rgba(232,255,0,0)',
      '0 0 60px rgba(232,255,0,0.5)',
      '0 0 0px rgba(232,255,0,0)'
    ],
    transition: { duration: 2.5, repeat: Infinity }
  }
}

export const FADE_IN_UP: Variants = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
}

export const FADE_IN: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.5 }
  }
}

export const SLIDE_IN_LEFT: Variants = {
  hidden: { x: -100, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: SPRING
  }
}

export const SLIDE_IN_RIGHT: Variants = {
  hidden: { x: 100, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: SPRING
  }
}
